var m = require('mithril');
var flatpickr = require('flatpickr/dist/flatpickr');
var styles = require('flatpickr/dist/flatpickr.min.css');
var moment = require('moment-timezone');

/** @namespace */
var rangePikaday = {};

/**
@param {date} value - the date we're selecting
*/

rangePikaday.oninit = function (vnode){
  var ctrl = this;
  ctrl.attrs = vnode.attrs;
  if (ctrl.attrs.value()[0] == null || ctrl.attrs.value()[1] == null) {
    let today = new Date();
    let mounthAgo = new Date();
    mounthAgo.setMonth(today.getMonth() - 1);
    ctrl.attrs.value([moment(today), moment(mounthAgo)])
  }  
}

rangePikaday.oncreate = function (vnode){
  var ctrl = this;
  ctrl.picker = new flatpickr(vnode.dom, {
    //altInput: true,
    //altFormat: "m/d/Y G:i K",
    altFormat: "m-d-Y",
    //enableTime: true,
    //enableSeconds: true,
    dateFormat: ctrl.attrs.dateFormat || 'Z',
    defaultDate: [ctrl.attrs.value()[0].toDate(), ctrl.attrs.value()[1].toDate()],
    time_24hr: ctrl.attrs.time_24hr,
    noCalendar: ctrl.attrs.noCalendar,
    mode: "range",
    //closeOnselect: true,
    onChange: function(ev) {
      var tsStart = moment.tz(ctrl.picker.selectedDates[0], 'America/New_York');
      var tsEnd = moment.tz(ctrl.picker.selectedDates[1], 'America/New_York');
      if(ctrl.attrs.updateQueryParams){
        var params = m.parseQueryString(m.route.get().split('?')[1]);
        params[ctrl.attrs.queryParamsNames[0]] = tsStart.format(ctrl.attrs.format);
        params[ctrl.attrs.queryParamsNames[1]] = tsEnd.format(ctrl.attrs.format);
        m.route.set(
          m.route.get().split('?')[0],
          params,
          ctrl.attrs.queryParamRouteOptions
        );
      }
      m.redraw();
      ctrl.attrs.value([tsStart.clone().tz('UTC'), tsEnd.clone().tz('UTC')]); // Convert this to UTC before it goes to the server
      
      if(ctrl.attrs.updateCallback && ctrl.picker.selectedDates[0] && ctrl.picker.selectedDates[1]) ctrl.attrs.updateCallback();
      if(ctrl.attrs.arrayUpdateCallback && Array.isArray(ctrl.attrs.arrayUpdateCallback()) && ctrl.picker.selectedDates[0] && ctrl.picker.selectedDates[1]) {
        ctrl.attrs.arrayUpdateCallback().forEach((func) => {
          func(false, [tsStart.clone().tz('UTC'), tsEnd.clone().tz('UTC')]);
        });
      }
    }
  })
}

rangePikaday.view = function(vnode) {
  var ctrl = this;
  return m('input.range-pikaday-input.dib.f4.no-min-height.no-background.pointer', {
    id: vnode.attrs.id ? vnode.attrs.id : '',
    type:'text', 
    placeholder: ctrl.attrs && ctrl.attrs.placeholder || 'Today',
  });
};

module.exports = rangePikaday;
